import { useFormContext, Controller } from 'react-hook-form';
import { StylishNewRadio } from 'components/DesignSystems/New/StylishNewRadio';
import FormTextField from '../../../formFields/FormTextField';

const SafetyPlanHealthSection = () => {
  const { control } = useFormContext();
  return (
    <div className="mb-3">
      <label className="form-label">Health and Safety Plan</label>
      <div className="d-flex gap-3 mb-2">
        <Controller
          name="healthAndSafetyPlan"
          control={control}
          render={({ field: { onChange, value } }) => (
            <StylishNewRadio
              id="hsp-yes"
              name="healthAndSafetyPlan"
              value="yes"
              label="Yes"
              checked={value === 'yes'}
              onChange={onChange}
              className=""
              disabled={false}
            />
          )}
        />
        <Controller
          name="healthAndSafetyPlan"
          control={control}
          render={({ field: { onChange, value } }) => (
            <StylishNewRadio
              id="hsp-no"
              name="healthAndSafetyPlan"
              value="no"
              label="No"
              checked={value === 'no'}
              onChange={onChange}
              className=""
              disabled={false}
            />
          )}
        />
      </div>
      <div className="mt-2">
        <FormTextField
          title="Health and Safety Plan Located at:"
          fieldName="healthAndSafetyPlanLocation"
          variant="full"
          placeholder="Enter location..."
        />
      </div>
    </div>
  );
};

export default SafetyPlanHealthSection;
